/**
 * Website copies of the activity summary shapes in the LLD (cce-4530, "API design"). They mirror
 * the Smithy model field for field so the mock fixtures and the generated client are
 * interchangeable. When the model ships (cce-8087), replace these with the generated types from
 * @amzn/red-velvet-api.
 */

export interface YearAndAllTimeCount {
  thisYear: number;
  allTime: number;
}

export interface TrackingCount {
  tracked: number;
  total: number;
}

// All eight metrics are listed up front so the coordinator summary (cce-8083) reuses this enum
// without touching shared shapes.
export enum ActivitySummaryMetric {
  VOLUNTEERING_SINCE = 'VOLUNTEERING_SINCE',
  SHIFTS_COMPLETED = 'SHIFTS_COMPLETED',
  VOLUNTEER_MINUTES = 'VOLUNTEER_MINUTES',
  ATTENDANCE_TRACKING = 'ATTENDANCE_TRACKING',
  COORDINATOR_SINCE = 'COORDINATOR_SINCE',
  EVENTS_ORGANIZED = 'EVENTS_ORGANIZED',
  AMAZONIANS_ACTIVATED = 'AMAZONIANS_ACTIVATED',
  SIGNUP_TRACKING = 'SIGNUP_TRACKING',
}

export interface VolunteerActivitySummary {
  year: number;
  volunteeringSince?: Date;
  shiftsCompleted?: YearAndAllTimeCount;
  volunteerMinutes?: YearAndAllTimeCount;
  attendanceTracking?: TrackingCount;
  unavailableMetrics: ActivitySummaryMetric[];
}

export interface GetVolunteerActivitySummaryResponse {
  // Absent when the caller has no signups and no attendance records.
  summary?: VolunteerActivitySummary;
}
